export default "__VITE_ASSET__D4I$aPa0__"